// VehicleSelection.js
import React, { useEffect, useState } from "react";
import AddonsSelection from "./AddonsSelection";
import { formatCurrency } from '../utils/currencyFormatter';
import { FaArrowLeft } from 'react-icons/fa';

const VehicleSelection = ({ isReturnBooking = false, context }) => {
  const {
    vehicles,
    returnVehicles,
    stopFee,
    returnStopFee,
    handleVehicleSelect,
    addons,
    returnAddons,
    setAddons,
    setReturnAddons,
    totalPrice,
    returnTotalPrice,
    loading,
    handleReturnBooking,
    handleVehicleSelectionNext,
    handleReturnVehicleSelectionNext
  } = context;

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [resetTrigger, setResetTrigger] = useState(0);
  const currentVehicles = isReturnBooking ? returnVehicles : vehicles;
  const currentStopFee = isReturnBooking ? returnStopFee : stopFee;
  const currentAddons = isReturnBooking ? returnAddons : addons;
  const setCurrentAddons = isReturnBooking ? setReturnAddons : setAddons;
  const currentTotalPrice = isReturnBooking ? returnTotalPrice : totalPrice;

  useEffect(() => {
    if (selectedVehicle) {
      const addExtrasSection = document.getElementById("add-extras-section");
      if (addExtrasSection) {
        addExtrasSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [selectedVehicle]);

  const handleVehicleSelectLocal = (vehicle) => {
    setSelectedVehicle(vehicle);
    setResetTrigger(prev => prev + 1);
    handleVehicleSelect(vehicle, isReturnBooking);

    const resetAddons = {
      babySeat: false,
      wineBottle: false,
      redCarpet: false,
      babySeatDetails: {
        infant: { selected: false, quantity: 0, price: 10, totalPrice: 0 },
        child: { selected: false, quantity: 0, price: 15, totalPrice: 0 },
        booster: { selected: false, quantity: 0, price: 20, totalPrice: 0 },
        totalBabySeatPrice: 0,
      },
      wineBottlePrice: 20,
      redCarpetPrice: 30,
    };

    setCurrentAddons(resetAddons);
  };

  const handleProceedNext = () => {
    if (isReturnBooking) {
      handleReturnVehicleSelectionNext();
    } else {
      handleVehicleSelectionNext();
    }
  };

  return (
    <div className="vehicle-selection-container">
      <div className="">
        <div className="vehicle-sheet shadow">
          <div className="sheet-header">
            <span className="sheet-header-bar"></span>
            <div className="sheet-title">Select Vehicle</div>
          </div>
          <div className="vehicles-list-container flex-grow-1">
            <div className="vehicles-list">
              {currentVehicles.map((vehicle) => {
                const totalPrice = vehicle.calculatedPrice + currentStopFee;
                
                return (
                  <div
                    key={vehicle.Vehicle_ID}
                    className={`vehicle-card ${selectedVehicle?.Vehicle_ID === vehicle.Vehicle_ID ? 'selected' : ''}`}
                    onClick={() => handleVehicleSelectLocal(vehicle)}
                  >
                    <img 
                      className="vehicle-image" 
                      src={vehicle.imageUrl} 
                      alt={vehicle.Vehicle_Name} 
                      crossOrigin="anonymous"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-vehicle.jpg';
                      }}
                    />
                    <div className="vehicle-info">
                      <div className="vehicle-type">{vehicle.Vehicle_Name}</div>
                      <div className="vehicle-desc">{vehicle.description || `or Similar`}</div>
                      <div className="vehicle-capacity">
                        <div className="capacity-item passengers">
                          <i className="fas fa-user-group"></i> {vehicle.Seating_Capacity || 3}
                        </div>
                        <div className="capacity-item luggage">
                          <i className="fas fa-suitcase-rolling"></i> {vehicle.Luggage || 2}
                        </div>
                      </div>
                    </div>
                    <div className="vehicle-price">{formatCurrency(totalPrice)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {selectedVehicle && (
          <div id="add-extras-section">
            <AddonsSelection
              key={`addons-${resetTrigger}`}
              addons={currentAddons}
              totalPrice={currentTotalPrice}
              onAddonChange={setCurrentAddons}
              onReturnBooking={handleReturnBooking}
              isReturnBooking={isReturnBooking}
              loading={loading}
            />
          </div>
        )}
      </div>

      <div className="footer-bar">
        <button 
          className="back-btn" 
          onClick={context.handleBack}
        >
          <FaArrowLeft />
        </button>
        <button 
          className={`btn-proceed ${!selectedVehicle ? 'disabled' : ''}`} 
          onClick={handleProceedNext}
          disabled={!selectedVehicle || loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Loading...
            </>
          ) : (
            'PROCEED NEXT'
          )}
        </button>
      </div>
    </div>
  );
};

export default VehicleSelection;
